var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PrestationsPage',{attrs:{"title_1":"Embellisement","title_2":"du regard","sections":_vm.sections,"images":_vm.images}})}
var staticRenderFns = []

export { render, staticRenderFns }